import CategoryTitleCard from './categoryTitleCard.container';

export default CategoryTitleCard;